import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { silentRefresh } from "../api";
import { tokenService } from "../services/tokenService";
import { SET_USER_DATA, LOGOUT_SUCCESS } from "../redux/actions/types";

const useSessionRestore = () => {
  const dispatch = useDispatch();
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const restore = async () => {
      try {
        const existingToken = tokenService.getAccessToken();
        const result = await silentRefresh();

        if (cancelled) return;

        if (result?.accessToken) {
          tokenService.setAccessToken(result.accessToken);
          if (result.user) {
            dispatch({ type: SET_USER_DATA, payload: result.user });
          }
        } else if (!existingToken) {
          // No fresh token AND no persisted token -> genuinely logged out.
          dispatch({ type: LOGOUT_SUCCESS });
        }
        // Otherwise keep the persisted session/token. If that token is stale,
        // the response interceptor will refresh it or trigger sessionExpired
        // on the first authenticated request.
      } catch {
        // Transient failure (network/timeout): keep any persisted session
        // instead of forcing a logout.
      } finally {
        if (!cancelled) {
          setIsInitialized(true);
        }
      }
    };

    restore();

    return () => {
      cancelled = true;
    };
  }, [dispatch]);

  return isInitialized;
};

export default useSessionRestore;
